module.exports = __webpack_public_path__ + "img/ZWF_Tomek_Alicja.5d591c6a.jpg";